import { Box } from "@chakra-ui/react";
import NavigationBar from "src/components/NavigationBar";

export default function WithNavigationBarLayout({
  navigationBarProps,
  childrenBoxProps = {},
  children
}) {
  const { css = {}, ...restOfProps } = childrenBoxProps;
  return (
    <Box width="100%" height="100%">
      <NavigationBar {...navigationBarProps} />
      <Box height="calc(100% - 61px)" {...css} {...restOfProps}>
        {children}
      </Box>
    </Box>
  );
}
